/** Ссылка для шаринга в браузере — подключение к стору и колбэкам (`app/share.ts`). */
import type { WindowProps } from "../kit";
import { useState } from "preact/hooks";
import { registerWindow } from "../../../app";
import { ShareLinkView } from "./view";
import { actions } from "../actions";

declare module "../../../app/state/window-route" {
  interface WindowRoutes {
    shareLink: { url: string; text: string; copied: boolean };
  }
}

export function ShareLink({ route, close }: WindowProps<"shareLink">) {
  const [copied, setCopied] = useState(route.copied);
  return (
    <ShareLinkView
      url={route.url}
      copied={copied}
      onCopy={() => void actions().copyShareLink(route.text, route.url).then(setCopied)}
      onDone={close}
    />
  );
}

export function register(): void {
  registerWindow("shareLink", ShareLink);
}
